import type { Transition } from "@uirouter/core";

import { swSettings } from "app/common/services/swSettings";
import type { TransitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const onRedirectUnsupportedDuration = (): TransitionHookFn => {
    return (transition: Transition) => {
        const toState = transition.to() as IRouterState;
        const params = transition.params();
        const configId = proNavigator.getConfigId(toState, params);
        const isAllowed = swSettings.allowedDuration(params.duration, configId, toState);
        const component = swSettings.components[configId];
        const firstAllowedDuration = component?.datePickerPresets.filter((preset) => preset.enabled)?.at(0)?.value;

        if (isAllowed) {
            return;
        }

        return {
            state: toState.name,
            params: {
                ...params,
                duration: firstAllowedDuration,
                ignoreFilterConsistency: true,
            },
        };
    };
};
